

export const QUERY_KEYS = {
    restaurantData: "getRestaurantData",
    Roles: "getAllRoles",
    FeatureGroups: "getAllFeatureGroups",
    Features: "getAllFeatures",
    categories: "getAllCategories",
    tableBookingRestaurantSettings: "getTableBookingRestaurantSettings",
    tableBookingOptions: "getTableBookingOptions",
    giftCardSettings: "getGiftCardSettings",
    allowedRedirectUris: "getAllowedRedirectUris",
    activeCountries: "getAllActiveCountries",
    country: "getCountryById",
    countries: "getCountries",
    countryList: "getCountryList",
}